<div>
<h2 class="step-title is-size-4-mobile">{{ title }}</h2>
<h3>{{ subtitle }}</h3>

<div class="field">
	<div [ngClass]="{'control': true}">
		<input *ngIf = "!inputModeTest"
		class="input is-large"
		[ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
		type="text" placeholder="(XXX) XXX-XXXX" formControlName="phoneNumber" [imask]="phoneMask" #phone (change)="phoneChange($event)" (input)="phoneInput($event)">

    <input *ngIf = "inputModeTest"
		inputmode="tel"
		class="input is-large"
		[ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
		type="text" placeholder="(XXX) XXX-XXXX" formControlName="phoneNumber" [imask]="phoneMask" #phone (change)="phoneChange($event)" (input)="phoneInput($event)">
	</div>

		<div *ngIf="controls[0].touched && controls[0].errors" class="help is-danger has-text-left">
			<p *ngIf="controls[0].errors.required">Phone Number is required.</p>
			<p *ngIf="controls[0].errors.pattern">Invalid Phone Number.</p>
		</div>
	</div>

	<div class="field lender-checkboxes" *ngIf="isShowLenders">
    <h4 class="get_lendes_title" *ngIf="selectedType.getValue() == 'top10'">
      Get Rates from {{branded.bank_name}} & checked lenders
      <span style="display: block;">(Click <input type="checkbox" checked style="margin: 0px"> to Uncheck)</span>
      <span style="font-size: 0.8em;display: block;">All Lenders are checked by default & displayed in a random order</span>
    </h4>
    <h4 class="get_lendes_title" *ngIf="selectedType.getValue() != 'top10'">
      Get Rates from Checked Lenders <span>(Click <input type="checkbox" checked style="margin: 0px"> to Uncheck)</span>
      <span style="font-size: 0.8em;display: block;">All Lenders are checked by default & displayed in a random order</span>
    </h4>

    <div *ngIf="showLenderError" class="is-danger help">
      At least one lender must be selected
    </div>

    <div class="columns">
      <div class="column">
        <div #lenderList class="lender-list">
          <div class="control has-text-centered" *ngFor="let lender of finalLenders; let i=index">
            <label [class]="['checkbox', lender?.featured && lender?.logo != ''? 'featured' : '']">
              <input type="checkbox"  formArrayName="lenders" (change)="onCheckChange($event)" [value]="lender.id" id = "leadid_tcpa_brandname_0{{i+1}}" [checked]="lender.checked && jornaya">
              <label [class]="lender?.logo != '' && lender?.featured ? 'is-hidden' : ''" for = "leadid_tcpa_brandname_0{{i+1}}"> {{ lender?.bank_name }}</label>
            </label>
          </div>
        </div>
      </div>
    </div>
	</div>

  <div class="field checkboxes" *ngIf="!isPreferBox">
    <div class="control has-text-centered">
      <label class="checkbox">
        <input type="checkbox" formControlName="sms" (change)="snap()">
        Prefers text
      </label>
    </div>
    <div class="control has-text-centered">
      <label class="checkbox">
        <input type="checkbox" formControlName="email_preference" (change)="snap()">
        Prefers email
      </label>
    </div>
    <!-- Functional Prefers Spanish Button -->
    <div class="control has-text-centered">
      <label class="checkbox">
        <input type="checkbox" formControlName="prefers_spanish" (change)="prefersSpanishSelected()">
        Prefers Spanish <span>(Espa<span>&#241;</span>ol)</span>
      </label>
    </div>
  </div>

	<button class="button continue is-large has-shadow-small" (click)="phoneSubmit(isUncheckedValidation)">
    {{ submitButtonText }}<span style="font-size: 15px; vertical-align: text-top;" *ngIf="isSelectedRun">*</span>
    <i class="fas fa-chevron-right"></i>
	</button>

  <div class="field checkboxes-new" *ngIf="isPreferBox">
    <label class="checkbox">
      <input type="checkbox" formControlName="sms" (change)="snap()">
      Prefers text
    </label>

    <label class="checkbox">
      <input type="checkbox" formControlName="email_preference" (change)="snap()">
      Prefers email
    </label>

    <label class="checkbox">
      <input type="checkbox" formControlName="prefers_spanish" (change)="prefersSpanishSelected()">
      Espa<span>&#241;</span>ol
    </label>
  </div>

	<!-- WARNING: The content of this disclosure is extremely important. Neither the text, nor the font size,
	nor the color may be changed, without confirmation with Ed and Anthony and approval from our lenders.-->

  <p class="tcpa is-size-7 has-text-grey-dark has-text-left" style="padding: 0 5px;" *ngIf="!isSelectedRun">
    <input type="hidden" id="leadid_tcpa_disclosure_form">
    <label for="leadid_tcpa_disclosure_form" class="disclosure-text">
      We take your privacy seriously. By clicking the button above, You agree that we can share your personal data with third parties, such as our mortgage partners, service providers and other affiliates, and that we can use this data for marketing and analytics, and to make your experience easier. you are also providing your<b>express written consent</b> to have your information shared and to be matched with up to five <a *ngIf="!fruLocalKiosk" href="/approved-lenders" target="_new" rel="nofollow">approved lenders</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">approved lenders</a> and for them, or their authorized third party, to call you at the number you have provided including through automated means such as autodialing, text SMS/MMS (charges may apply), and prerecorded messaging, and/or via email, even if your telephone number is a cellular phone number or on a corporate, state, or the National Do Not Call Registry, and you agree to our Privacy Policy <a *ngIf="!fruLocalKiosk" href="/privacy" target="_new" rel="nofollow">Privacy Policy</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">Privacy Policy</a>. Consent is not required as a condition to utilize FreeRateUpdate's services, you may choose to use our services by calling 855-315-7283. Consent is not contingent on the purchase and/or use of any services being offered by a Lender.
    </label>
  </p>

  <p class="tcpa-2 is-size-7 has-text-grey-dark has-text-left" style="padding: 0 5px;" *ngIf="!isSelectedRun">
    <label class="disclosure-text" for="leadid_tcpa_disclosure_form">
      Message frequency varies. Call 855-315-7283 for help. Text STOP to cancel. <a *ngIf="!fruLocalKiosk" href="/privacy_policy.php" rel="nofollow" target="_blank">Terms and Conditions</a><a *ngIf="fruLocalKiosk" (click)="closeModal()">Terms and Conditions</a>
    </label>
  </p>

  <p class="tcpa is-size-7 has-text-grey-dark has-text-left" style="padding: 0 5px;" *ngIf="isSelectedRun">
    <input type="hidden" id="leadid_tcpa_disclosure_form">
    <label for="leadid_tcpa_disclosure_form" class="disclosure-text">
      *By clicking "Get Rates" above, I am electronically signing this web-form and giving my express written consent for FreeRateUpdate.com LLC and the companies selected (checked) above to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgages and home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of automatically dialed voice calls and SMS/MMS messages and prerecorded or artificial voice messages. Message and data rates may apply. I acknowledge that there are up to 6 lenders pre-selected in the list above and that I may de-select any or all of them before I submit this web-form. By leaving lenders checked I am affirmatively choosing and consenting to receive mortgage and home equity marketing information from those lenders. To de-select lenders, I understand that I should click the checked box next to the lender’s name. I acknowledge that my consent is not required to obtain mortgage or home equity product marketing from FreeRateUpdate.com LLC or a mortgage or a home equity product from the company or companies listed above.
    </label>
  </p>

  <div *ngIf="canEditScores" class="field edit-scores">
    Manual Override
    <label>Phone Score: 
      <input type="number" class="input" formControlName="phonescore_override" step="5" min="0" max="100" />
    </label>
    <label>Email Score: 
      <input type="number" class="input" formControlName="emailscore_override" step="5" min="0" max="100" />
    </label>
    <div style="clear:both"></div>
  </div>
</div>
